export { HeroSpeechToText } from './HeroSpeechToText';
export {
	buildSpeechToTextCookie,
	SPEECH_TO_TEXT_COOKIE_OPTIONS,
} from './speechToTextCookie';
